import type { BuilderFlags } from "helpers/AppProvider.types";

import { BTAdminBuilderPreference } from "handlers";

/**
 * DO NOT USE
 * This will detect if the current instance is being run in a test
 * You should never do this, this method was added as a hack to fix a third party compatibility bug with CKEditor running in tests
 */
export function isUnitTest() {
    return (
        import.meta.env.MODE === "test" ||
        navigator.userAgent.includes("Node.js") ||
        navigator.userAgent.includes("jsdom")
    );
}

enum SentryEnvironments {
    Ephemeral = "Ephemeral",
    Arch = "Sandbox",
    ArchiveSites = "Archive",
    AutomatedTesting = "at.buildertrend.net",
    Staging = "Sandbox",
    Dev = "Dev",
    Test = "Test",
    Production = "Production",
    Unknown = "Unknown",
}

export function getCurrentSentryEnvironment(): SentryEnvironments {
    const hostName: string = window.location.hostname;

    if (hostName.includes(".ephpr.")) {
        return SentryEnvironments.Ephemeral;
    } else if (hostName.includes("arch.")) {
        return SentryEnvironments.Arch;
    } else if (hostName.includes("archives.")) {
        return SentryEnvironments.ArchiveSites;
    } else if (hostName.includes("at.")) {
        return SentryEnvironments.AutomatedTesting;
    } else if (hostName.includes("staging.")) {
        return SentryEnvironments.Staging;
    } else if (
        hostName.includes("dev.buildertrend.net") ||
        hostName.includes("local.buildertrend.net") ||
        hostName.includes("localhost") ||
        hostName.includes("127.0.0.1")
    ) {
        return SentryEnvironments.Dev;
    } else if (hostName.includes("test.")) {
        return SentryEnvironments.Test;
    } else if (hostName === "buildertrend.net") {
        return SentryEnvironments.Production;
    }

    return SentryEnvironments.Unknown;
}

export function getCurrentEnvironment(): string {
    const hostName: string = window.location.hostname;
    let environment: string;

    if (hostName.includes("arch.")) {
        environment = "arch";
    } else if (hostName.includes("archives.")) {
        environment = "archivesites";
    } else if (hostName.includes("at.")) {
        environment = "at";
    } else if (hostName.includes("staging.")) {
        environment = "staging";
    } else if (hostName.includes("dev.buildertrend.net") || hostName.includes(".ephpr.")) {
        environment = hostName.split(".")[0];
    } else if (
        hostName.includes("localhost") ||
        hostName.includes("127.0.0.1") ||
        hostName.includes("local.buildertrend.net")
    ) {
        environment = "dev";
    } else if (hostName.includes("test.")) {
        environment = "test";
    } else if (hostName === "buildertrend.net") {
        environment = "prod";
    } else {
        environment = "unknown";
    }
    return environment;
}

export const getAutomatedTestBuilderFlags = () => {
    // set up mapping to do case insensitive match on flag names
    const possibleFlags = Object.keys(BTAdminBuilderPreference) as (keyof BuilderFlags)[];
    const lowerToFlagNameMap = possibleFlags.reduce(
        (acc, flagName) => {
            acc[flagName.toLowerCase()] = flagName;
            return acc;
        },
        {} as Record<string, keyof BuilderFlags | undefined>,
    );

    return (
        (import.meta.env.BT_AT_TRUE_BUILDER_FLAGS as string | undefined)
            ?.split(",")
            .reduce((acc, envFlag) => {
                // look for case insensitive match and map back to actual property name
                const flagName = lowerToFlagNameMap[envFlag.trim().toLowerCase()];
                if (flagName) {
                    acc[flagName] = true;
                }
                return acc;
            }, {} as Partial<BuilderFlags>) ?? {}
    );
};
